/**
 * Created by piotr.pozniak@thebeaverhead.com on 01/12/2021.
 */

import React from "react";
import classnames from "classnames";
import EventBadge from "./EventBadge";
import { useTranslation } from "react-i18next";

/**
 * EventBadges component displays badges for events such as recurring or featured.
 * @param props
 * @param {boolean} props.showRecurringBadge - Whether to show the recurring badge.
 * @param {boolean} props.showFeaturedBadge - Whether to show the featured badge.
 * @param {string} props.location - The location of the badges (default is "image-top").
 *
 * @returns {Element}
 * @constructor
 */
const EventBadges = (props) => {
  const badges = [];

  const { t } = useTranslation();
  if (props.showRecurringBadge) {
    badges.push({
      label: t("Recurring"),
      icon: "autorenew",
      badgeType: "recurring",
    });
  }

  if (props.showFeaturedBadge) {
    badges.push({
      label: t("Featured"),
      icon: "star_outline",
      badgeType: "featured",
    });
  }

  const eventBadges = badges.map((i, idx) => {
    return (
      <EventBadge
        key={`ebg-${idx}`}
        label={i.label}
        icon={i.icon}
        badgeType={i.badgeType}
      />
    );
  });

  const badgeLocation = props.location || "image-top";

  return (
    <div
      className={classnames(
        `dce--event-badge_container-position-${badgeLocation}`,
        "dce--event-badge_container"
      )}
    >
      {eventBadges}
    </div>
  );
};

export default EventBadges;
